import type { SVGProps } from 'react';

const SvgDivide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 11H5c-.55 0-1 .45-1 1s.45 1 1 1h14c.55 0 1-.45 1-1s-.45-1-1-1m-8.29-4.29.29-.29v2.59c0 .55.45 1 1 1s1-.45 1-1V6.42l.29.29c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2-2a.996.996 0 0 0-1.41 0l-2 2a.996.996 0 1 0 1.41 1.41m2.58 10.58-.29.29v-2.59c0-.55-.45-1-1-1s-1 .45-1 1v2.59l-.29-.29A.996.996 0 1 0 9.3 18.7l2 2c.2.2.45.29.71.29s.51-.1.71-.29l2-2a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgDivide;
